var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c(
          "h4",
          {
            staticClass: "card-title cursor-pointer",
            on: {
              click: function($event) {
                return _vm.toggleCollase()
              }
            }
          },
          [
            _c("feather-icon", {
              attrs: {
                icon: !_vm.isAccordionOpen ? "ChevronDownIcon" : "ChevronUpIcon"
              }
            }),
            _vm._v(" Filtros ")
          ],
          1
        ),
        _c(
          "b-collapse",
          {
            attrs: {
              id: "accordion-filters",
              accordion: "accordion-filters",
              role: "tabpanel",
              block: "",
              visible: _vm.isAccordionOpen
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Desatendida" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter(
                            "aprobacionesAtendidas",
                            _vm.inDesAttended
                          )
                        }
                      },
                      model: {
                        value: _vm.inDesAttended,
                        callback: function($$v) {
                          _vm.inDesAttended = $$v
                        },
                        expression: "inDesAttended"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "desatendida:1", text: "Si" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "desatendida:0", text: "No" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Está en curso" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter(
                            "aprobacionesActivas",
                            _vm.inProgress
                          )
                        }
                      },
                      model: {
                        value: _vm.inProgress,
                        callback: function($$v) {
                          _vm.inProgress = $$v
                        },
                        expression: "inProgress"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "aprobacionesActivas:>=1", text: "Si" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "aprobacionesActivas:0", text: "No" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Unidad" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter("unidad", _vm.unit)
                        }
                      },
                      model: {
                        value: _vm.unit,
                        callback: function($$v) {
                          _vm.unit = $$v
                        },
                        expression: "unit"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _vm._l(_vm.units, function(item) {
                        return _c("vs-select-item", {
                          key: item.id,
                          attrs: {
                            autocomplete: "",
                            value: "unidad:" + item.id,
                            text: item.nombre
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Tipo flujo" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter("tipoEjecucion", _vm.flowType)
                        }
                      },
                      model: {
                        value: _vm.flowType,
                        callback: function($$v) {
                          _vm.flowType = $$v
                        },
                        expression: "flowType"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "tipoEjecucion:N", text: "Normal" }
                      }),
                      _c("vs-select-item", {
                        attrs: { value: "tipoEjecucion:P", text: "Por monto" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Estado" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter("aprobacionesEstado", _vm.active)
                        }
                      },
                      model: {
                        value: _vm.active,
                        callback: function($$v) {
                          _vm.active = $$v
                        },
                        expression: "active"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _c("vs-select-item", {
                        attrs: {
                          value: "aprobacionesEstado:Y",
                          text: "Activas"
                        }
                      }),
                      _c("vs-select-item", {
                        attrs: {
                          value: "aprobacionesEstado:N",
                          text: "Inactivas"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c(
                    "vs-select",
                    {
                      staticClass: "w-100",
                      attrs: { autocomplete: "", label: "Doc. Referencia" },
                      on: {
                        change: function($event) {
                          return _vm.setFilter("tipoObjeto", _vm.referenceDoc)
                        }
                      },
                      model: {
                        value: _vm.referenceDoc,
                        callback: function($$v) {
                          _vm.referenceDoc = $$v
                        },
                        expression: "referenceDoc"
                      }
                    },
                    [
                      _c("vs-select-item", {
                        attrs: { value: "*", text: "Todo" }
                      }),
                      _vm._l(_vm.sortedReferenceApprovals, function(item) {
                        return _c("vs-select-item", {
                          key: item.opcionId,
                          attrs: {
                            autocomplete: "",
                            value: "tipoObjeto:" + item.valor,
                            text: item.descripcion
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-4" },
                [
                  _c("vs-input", {
                    staticClass: "w-100",
                    attrs: {
                      label: "Búsqueda por nombre",
                      placeholder: "Ej: Aprobación 455"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        return _vm.setFilter("nombre", "nombre$" + _vm.name)
                      }
                    },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }